import { useLayoutEffect, useRef } from "react"

const useScrollToBottom = <Element extends HTMLElement>(
  ...triggers: unknown[]
) => {
  const scrollRef = useRef<Element>(null)

  useLayoutEffect(() => {
    if (!scrollRef.current) return

    scrollRef.current.scrollTop = scrollRef.current.scrollHeight
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, triggers)

  return scrollRef
}

export default useScrollToBottom
